module.exports = __webpack_public_path__ + "static/media/news_slider_phone1.139c97de.png";